import styled from 'styled-components';

export const Warrper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
